(function() {
  'use strict';

  angular.module('ringbaPortal.services').factory('concurrencyMatrixService', concurrencyMatrixService);

  function concurrencyMatrixService(_) {
    const service = {
      getProcessMatrix: getProcessMatrix,
      postProcessMatrix: postProcessMatrix
    };
    return service;

    // Originally had this as one process with toggle like logic,
    // But prefer to call it explicitely

    // Process incoming matrix
    function getProcessMatrix(matrix) {
      _.forEach(matrix, function(day, dayIndex) {
        _.forEach(day, function(hour, hourIndex) {
          if (hour === -1) {
            matrix[dayIndex][hourIndex] = null;
          }
        });
      });
      // Shift days because API expects 0-6 to be Sun-Sat we are 0-6 Mon-Sun
      if (matrix && matrix.push) {
        matrix.push(matrix.shift());
      }

      return matrix;
    }

    // Process outgoing matrix
    function postProcessMatrix(matrix) {
      _.forEach(matrix, function(day, dayIndex) {
        _.forEach(day, function(hour, hourIndex) {
          if (hour === null) {
            matrix[dayIndex][hourIndex] = -1;
          }
        });
      });
      // Shift days because API expects 0-6 to be Sun-Sat we are 0-6 Mon-Sun
      if (matrix && matrix.push) {
        for (let i = 0; i < 6; i++) {
          matrix.push(matrix.shift());
        }
      }
      return matrix;
    }
  }
})();
